import { mapGetters } from "vuex";

export default {
    props: {
        word: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        ...mapGetters(["currentLanguage"]),
        pattern() {
            if (this.word === null) return null;
            return new RegExp(this.word, "gi");
        },
        emphasizeWord() {
            const word = this.word;
            const introText = this.$t("sentenceDetailPageIntroText", {
                word: `${word}`
            });
            if (this.word === null) return null;
            return introText.replace(
                this.pattern,
                match => `<span class="emphasis">${match}</span>`
            );
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/DetailIntroText/DetailIntroText.js